export default function modal(){
    const open = document.getElementById('fdSubscribe');
    const close = document.getElementById('modalClose');
    const modal = document.getElementById('siteModal');
    const outClick = document.querySelector('body');

    let firstTime = localStorage.getItem("firstTime");
   
    if(! firstTime){
        localStorage.setItem("firstTime", true);
        setTimeout(()=>{ modal.style.display = "flex";},1600)
    }
  
    close.addEventListener('click', ()=>{
        modal.classList.remove('open')
    })


    open.addEventListener('click', (e)=> {   
        e.preventDefault;   
        modal.style.display = "flex";
        setTimeout(()=>{modal.classList.add('open');} , 10)
        outClick.addEventListener('click', (event)=>{
            if( event.target.className === 'fd-modal__overlay'){
                modal.classList.remove('open');
            }
        })
        close.addEventListener('click', ()=>{
            modal.classList.remove('open')
        })
    })

}